/**
 * Normalize Vuetify 2/3 table sort options for server-side API calls.
 */
export function getDatatableSortParams(options, defaultSortBy = 'updated_at', defaultDesc = true) {
  if (!options) {
    return {
      sortBy: defaultSortBy,
      sortDesc: defaultDesc ? 'true' : 'false',
    };
  }

  let sortBy = options.sortBy;
  let sortDesc = options.sortDesc;

  if (Array.isArray(sortBy) && sortBy.length > 0) {
    const first = sortBy[0];
    if (first && typeof first === 'object' && first.key) {
      return {
        sortBy: first.key,
        sortDesc: first.order === 'desc' ? 'true' : 'false',
      };
    }
    sortBy = first;
  }

  if (Array.isArray(sortDesc) && sortDesc.length > 0) {
    sortDesc = sortDesc[0];
  }

  if (!sortBy) {
    return {
      sortBy: defaultSortBy,
      sortDesc: defaultDesc ? 'true' : 'false',
    };
  }

  const desc =
    sortDesc === true ||
    sortDesc === 'true' ||
    sortDesc === 1 ||
    sortDesc === '1';

  return {
    sortBy: String(sortBy),
    sortDesc: desc ? 'true' : 'false',
  };
}
